import test from './api.service';
import axios from 'axios';

class FilterService {
    getFilters() {
        return test.get('/comptage/filter').then(
            (res)=> {
                return this.getJsonFromS3Url(res.data.message.url)
            }
        )
    }
    getJsonFromS3Url(url: string) {
        return axios.get(url);
    }
}

export default new FilterService();
